export const API_PREFIX = '/tch/impact'

export const RULE_VERSION = 'v1 · 2026-10-22'

export const DATA_SOURCE = '欧美外教 · 常规外教课 · 实时计算'

export const DAY_OPTIONS = [
  { value: 7, label: '近 7 天' },
  { value: 30, label: '近 30 天' },
  { value: 90, label: '近 90 天' }
]

export const TYPE_META = {
  resign: { label: '离职', color: '#7C5CFF', badge: 'is-purple' },
  elim: { label: '淘汰', color: '#E6464E', badge: 'is-danger' },
  close: { label: '关闭时间', color: '#E89F2D', badge: 'is-warning' },
  tleave: { label: '3h内请假', color: '#FF8F3D', badge: 'is-warning' },
  leave: { label: '请假', color: '#5B8FF9', badge: 'is-info' },
  absent: { label: '旷课', color: '#B3312F', badge: 'is-danger' }
}

export const LEVEL_BADGE = {
  '极高': 'is-deep',
  '高': 'is-danger',
  '中': 'is-warning',
  '低': 'is-gray'
}

export const STATUS_BADGE = {
  '流失预警': 'is-danger',
  '待换老师': 'is-warning',
  '已换老师': 'is-healthy',
  '正常上课': 'is-info'
}

export function typeLabel (type) {
  return (TYPE_META[type] && TYPE_META[type].label) || type || '—'
}

export function typeColor (type) {
  return (TYPE_META[type] && TYPE_META[type].color) || '#A7AEBC'
}

export function typeBadge (type) {
  return (TYPE_META[type] && TYPE_META[type].badge) || 'is-gray'
}

export function isNum (v) {
  return v !== null && v !== undefined && v !== '' && !isNaN(Number(v))
}

export function num (v) {
  return isNum(v) ? Number(v) : 0
}

export function fmtNum (v, digits) {
  if (!isNum(v)) {
    return '—'
  }
  let d = digits == null ? 1 : digits
  return Number(v).toLocaleString('en-US', { maximumFractionDigits: d })
}

export function fmtRate (v) {
  return isNum(v) ? Number(v).toFixed(1) + '%' : '—'
}

export function fmtRateNum (v) {
  return isNum(v) ? Number(v).toFixed(1) : '—'
}

export function shortDate (s) {
  return s && s.length >= 10 ? s.slice(5, 10) : (s || '—')
}

// 越高越好：≥ good 健康，≥ warn 关注，否则预警；无数据按健康
export function levelHigh (v, good, warn) {
  if (!isNum(v)) {
    return 'healthy'
  }
  let n = Number(v)
  if (n >= good) {
    return 'healthy'
  }
  return n >= warn ? 'warning' : 'danger'
}

// 越低越好：≥ danger 预警，≥ warn 关注，否则健康
export function levelLow (v, warn, danger) {
  if (!isNum(v)) {
    return 'healthy'
  }
  let n = Number(v)
  if (n >= danger) {
    return 'danger'
  }
  return n >= warn ? 'warning' : 'healthy'
}

// 越少越好的计数与上期比：变多预警、持平关注、变少健康
export function levelVsPrev (cur, prev) {
  let c = num(cur)
  if (c <= 0) {
    return 'healthy'
  }
  if (!isNum(prev)) {
    return 'warning'
  }
  let p = Number(prev)
  if (c > p) {
    return 'danger'
  }
  return c === p ? 'warning' : 'healthy'
}

// 越少越好的环比文案：{ text, tone }
export function changeVsPrev (cur, prev, unit) {
  if (!isNum(cur) || !isNum(prev)) {
    return { text: '', tone: 'neutral' }
  }
  let c = Number(cur)
  let p = Number(prev)
  let tail = ' 上期 ' + fmtNum(p) + (unit || '')
  if (p === 0) {
    return c > 0 ? { text: '新增' + tail, tone: 'danger' } : { text: '持平' + tail, tone: 'neutral' }
  }
  let pct = (c - p) / p * 100
  if (pct === 0) {
    return { text: '持平' + tail, tone: 'neutral' }
  }
  return {
    text: (pct > 0 ? '↑ ' : '↓ ') + Math.abs(pct).toFixed(1) + '%' + tail,
    tone: pct > 0 ? 'danger' : 'healthy'
  }
}

export function sumCount (list, key) {
  return (list || []).reduce(function (n, item) {
    return n + num(item[key || 'count'])
  }, 0)
}

export function cleanParams (params) {
  let out = {}
  Object.keys(params || {}).forEach(function (k) {
    let v = params[k]
    if (v !== null && v !== undefined && v !== '') {
      out[k] = v
    }
  })
  return out
}

// 快速切换筛选时只认同一 path 最后一次请求；旧请求永不 settle，免得覆盖数据或提前关掉 loading
export function postImpact (vm, path, params) {
  let seqs = vm._impactSeq || (vm._impactSeq = {})
  let seq = (seqs[path] || 0) + 1
  seqs[path] = seq
  return vm.$http.post(API_PREFIX + path, cleanParams(params), { silent: true }).then(function (res) {
    if (res && res.status === 'ok') {
      return res.data || {}
    }
    if (seqs[path] === seq) {
      vm.$Message.error((res && res.msg) || '加载失败')
    }
    return null
  }).catch(function () {
    return null
  }).then(function (data) {
    return seqs[path] === seq ? data : new Promise(function () {})
  })
}

function decodeErrorMsg (buf) {
  try {
    let text = new TextDecoder('utf-8').decode(new Uint8Array(buf))
    let json = JSON.parse(text)
    return json.msg || '导出失败'
  } catch (e) {
    return '导出失败'
  }
}

export function exportImpact (vm, params, fileName) {
  return vm.$http.post(API_PREFIX + '/export', cleanParams(params), {
    responseType: 'arraybuffer',
    silent: true
  }).then(function (res) {
    if (res && res.headers && res.data) {
      let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setTimeout(function () {
        window.URL.revokeObjectURL(link.href)
      }, 1000)
      return true
    }
    let msg = res instanceof ArrayBuffer ? decodeErrorMsg(res) : ((res && res.msg) || '导出失败')
    vm.$Message.error(msg)
    return false
  }).catch(function () {
    return false
  })
}



// WEBPACK FOOTER //
// ./src/components/tchImpact/parts/impact.js